<template>
  <div class="regional-info">
    <div class="regional-info__form-group">
      <label>{{ $t('regional-manager.editing.info.name') }}*</label>
      <b-form-input
        v-model="regional.name"
        maxlength="80"
        :state="$bsStateValidator($v.regional.name.$error)"
        @blur.native="$v.regional.name.$touch()"
        @change="setNameInvalid"
      ></b-form-input>
      <b-form-invalid-feedback
        v-if="showRegionalNameTooltip($v.regional.name)"
        :state="$bsStateValidator($v.regional.name.$error)">
        {{
          $t('messages.MG001.message', {
            0: 2,
            1: 80,
          })
        }}
      </b-form-invalid-feedback>
    </div>

    <div class="regional-info__form-group">
      <label>{{ $t('regional-manager.editing.info.description') }}</label>
      <b-form-textarea
        v-model="regional.description"
        maxlength="200"
        :rows="3"
        :state="$bsStateValidator($v.regional.description.$error)"
        @blur.native="$v.regional.description.$touch()"
      />
    </div>

    <div class="regional-info__form-group">
      <label>{{ $t('regional-manager.editing.info.company') }}*</label>
      <s-select
        v-model="regional.companyId"
        value-field="id"
        text-field="name"
        :options="companies"
        :state="$bsStateValidator($v.regional.companyId.$error)"
        @blur="$v.regional.companyId.$touch()"
        @change="getCompanyName(regional.companyId)"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .regional-info
    &__form-group
      margin-bottom: 14px
</style>


<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import CompanyService from '@/domain/services/company';
import RegionalService from '@/domain/services/generalPanel/adminPanel/regional/regionalService';

const SEARCH_DELAY = 1000;
export default {
  props: { regional: Object, valid: Boolean },
  data() {
    return {
      nameIsValid: false,
      searchListener: {},
      searchDuplicatedNames: false,
      companies: [],
    };
  },
  validations: {
    regional: {
      name: {
        required,
        maxLength: maxLength(80),
      },
      description: {
        maxLength: maxLength(200),
      },
      companyId: { required },
    },
  },
  computed: {
    formValid() {
      return !this.$v.$invalid;
    },
    isValid() {
      return this.formValid && this.nameIsValid;
    },
    selectedCompanyId() {
      if (!this.regional) {
        return null;
      }
      return this.regional.companyId;
    },
  },
  created() {
    this.getCompanies();
  },
  methods: {
    async getCompanies() {
      const response = await CompanyService.getCompanies();

      this.companies = [
        {
          id: null,
          name: this.$t('general.select'),
        },
        ...response,
      ];
      if (this.companies.length === 2) {
        this.regional.companyId = this.companies[1].id;
      }
    },
    showRegionalNameTooltip(validationModel) {
      return validationModel.$error
        && (!validationModel.required
          || !validationModel.minLength
        );
    },
    validateRegionalName() {
      if (!this.regional.companyId) {
        this.$emit('update:valid', this.isValid);
        this.$emit('update:loading', false);
        return;
      }

      this.searchListener = setTimeout(() => {
        RegionalService.getRegionalLookup([this.regional.companyId])
          .then((data) => {
            const duplicatedRegionals = data
              .filter(item => item.name.toLowerCase() === this.regional.name.toLowerCase()
                && item.id !== this.regional.id);
            this.nameIsValid = duplicatedRegionals.length === 0;
            this.$emit('update:valid', this.isValid);
            if (!this.nameIsValid) {
              const companyName = this.companies
                .find(company => company.id === this.regional.companyId).name;
              this.$pushAlert({
                code: 'MA018',
                messageParams: {
                  NomeEmpresa: companyName,
                },
              });
            }
          })
        .finally(() => this.$emit('update:loading', false));
      }, SEARCH_DELAY);
    },
    getCompanyName(companyId) {
      if (!companyId) {
        return;
      }
      const selectedCompany = this.companies.find(company => company.id === companyId);
      if (!selectedCompany) {
        return;
      }
      this.regional.companyName = selectedCompany.name;
      this.setNameInvalid();
    },
    setNameInvalid() {
      this.nameIsValid = false;
      this.searchDuplicatedNames = true;
    },
  },
  watch: {
    formValid(value) {
      this.$emit('update:valid', this.isValid);
      clearTimeout(this.searchListener);
      if (value) {
        this.$emit('update:loading', true);
        this.validateRegionalName();
      }
    },
    searchDuplicatedNames(value) {
      this.$emit('update:valid', this.isValid);
      clearTimeout(this.searchListener);
      if (!value) {
        this.$emit('update:loading', true);
        this.validateRegionalName();
      }

      this.searchDuplicatedNames = false;
    },
    selectedCompanyId(newCompanyId) {
      this.getCompanyName(newCompanyId);
    },
  },
};
</script>
